const vhUnit = () => {
	const header = document.querySelector( '.main-header' );
	document.documentElement.style.setProperty(
		'--vh',
		`${ window.innerHeight * 0.01 }px`,
	);
	document.documentElement.style.setProperty(
		'--headerHeight',
		`${ header.clientHeight * 0.01 }px`,
	);
};

export default vhUnit;
